// extracted by mini-css-extract-plugin
export default {"slot":"DockRightSlot_slot__8-C6E"};